export default __webpack_public_path__ + "static/media/start_with_us.a8c6268f.gif";